import { reduce } from "lodash/collection";
import { keys } from "lodash/object";

const removeEmptyFieldsFromObject = (obj) => {
  return reduce(
    keys(obj),
    (finalObj, key) => {
      if (obj[key] && typeof obj[key] === "object") {
        const nestedObj = removeEmptyFieldsFromObject(obj[key]);
        if (Object.keys(nestedObj).length) {
          finalObj[key] = nestedObj;
          return finalObj;
        }
        return finalObj;
      }

      if (obj[key] !== "" && obj[key] !== undefined && obj[key] !== null) {
        finalObj[key] = obj[key];
        return finalObj;
      }

      return finalObj;
    },
    {}
  );
};

export { removeEmptyFieldsFromObject };
